import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaYoutube } from 'react-icons/fa';
import '../alert/Alert.css';
import './AppSupportLanding.css';
import supportLogo from '../../SE Support.svg';

/**
 * App Support landing page with quick navigation to requests, docs, and version information.
 */
export default function AppSupportLanding() {
    const navigate = useNavigate();

    return (
        <div className="alert-home-container">
            <div className="appsupport-landing-card">
                <img className="appsupport-landing-logo" src={supportLogo} alt="SE Support" />
                <p className="appsupport-landing-subtitle">
                    Choose where you want to go.
                </p>

                <div className="appsupport-landing-actions">
                    <button
                        type="button"
                        className="appsupport-landing-button"
                        onClick={() => navigate('/app/support/docs')}
                    >
                        <span className="appsupport-landing-button-content">
                            <span className="appsupport-landing-button-title">Documentation</span>
                            <span className="appsupport-landing-button-description">
                                Step-by-step guides for using School Engine modules and pages.
                            </span>
                        </span>
                    </button>
                    <button
                        type="button"
                        className="appsupport-landing-button"
                        onClick={() => navigate('/app/support/requests')}
                    >
                        <span className="appsupport-landing-button-content">
                            <span className="appsupport-landing-button-title">Support Requests</span>
                            <span className="appsupport-landing-button-description">
                                Submit a new request and track your current App Support cases.
                            </span>
                        </span>
                    </button>
                    <button
                        type="button"
                        className="appsupport-landing-button"
                        onClick={() => navigate('/app/support/about')}
                    >
                        <span className="appsupport-landing-button-content">
                            <span className="appsupport-landing-button-title">Web App Version Information</span>
                            <span className="appsupport-landing-button-description">
                                Version information, change log details, and third-party package information for the web app.
                            </span>
                        </span>
                    </button>
                    <a
                        className="appsupport-landing-button appsupport-landing-button-link"
                        href="https://www.youtube.com/@schoolengine/videos"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <FaYoutube className="appsupport-landing-button-icon" aria-hidden="true" />
                        <span className="appsupport-landing-button-content">
                            <span className="appsupport-landing-button-title">YouTube Channel</span>
                            <span className="appsupport-landing-button-description">
                                Watch School Engine video guides, walkthroughs, and feature updates on YouTube.
                            </span>
                        </span>
                    </a>
                </div>

            </div>
        </div>
    );
}
